import { render, staticRenderFns } from "./CatalogBarWithProviderFilter.vue?vue&type=template&id=ba79b1ea&"
import script from "./CatalogBarWithProviderFilter.vue?vue&type=script&lang=js&"
export * from "./CatalogBarWithProviderFilter.vue?vue&type=script&lang=js&"
import style0 from "./CatalogBarWithProviderFilter.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba79b1ea')) {
      api.createRecord('ba79b1ea', component.options)
    } else {
      api.reload('ba79b1ea', component.options)
    }
    module.hot.accept("./CatalogBarWithProviderFilter.vue?vue&type=template&id=ba79b1ea&", function () {
      api.rerender('ba79b1ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/tusk/modules/components/CatalogBarWithProviderFilter.vue"
export default component.exports